var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.338,
    height: 18.435,
    viewBox: "0 0 14.338 18.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.524,20.886a2.054,2.054,0,0,0,2.048,2.048h8.193a2.054,2.054,0,0,0,2.048-2.048V8.6H8.524Zm2.519-7.292,1.444-1.444,2.181,2.171L16.84,12.15l1.444,1.444-2.171,2.171,2.171,2.171L16.84,19.381,14.669,17.21,12.5,19.381l-1.444-1.444,2.171-2.171Zm7.21-8.07L17.229,4.5H12.109L11.084,5.524H7.5V7.572H21.838V5.524Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#fd6c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelOrange);
export default __webpack_public_path__ + "static/media/del_orange.287eb5d23da9adaf174630680a517c68.svg";
export { ForwardRef as ReactComponent };